import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { hydrateFromUrlSid } from './lib/sessionHydration';
import { stashLandingParams } from './lib/landingAttribution';
import './styles/globals.css';

// If the URL has `?sid=<uuid>`, pull the server-side session into the
// Zustand store before React renders. This is what makes shareable
// pricing URLs work on fresh devices. Fires-and-renders in parallel —
// we don't await — so a slow DB lookup never blocks the initial paint.
// Components that read store state will re-render once setState fires.
// Capture landing-URL tags (utm, gclid, review-site lp_*) before anything
// can redirect them away. See src/lib/landingAttribution.ts.
stashLandingParams();

void hydrateFromUrlSid();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
